<aside
  class="cookie-consent"
  role="region"
  aria-live="polite"
  aria-labelledby="cookie-consent-title"
  aria-describedby="cookie-consent-description cookie-consent-prompt"
>
  <div class="cookie-consent__heading">
    <mat-icon aria-hidden="true">cookie</mat-icon>
    <h2 id="cookie-consent-title">Cookies while using SyRF</h2>
  </div>

  <div class="cookie-consent__copy">
    <p id="cookie-consent-description">
      We use cookies for security purposes, remembering your preferences and to
      analyse site traffic to understand our users' behaviour. This includes
      anonymised Google Analytics data.
    </p>
    <p id="cookie-consent-prompt">
      Please let us know if you agree to these cookies.
    </p>
  </div>

  <div class="cookie-consent__actions">
    <a mat-button matExpButton routerLink="/about/cookies">MORE INFO</a>
    <button mat-flat-button matExpButton type="button" (click)="accepted.emit()">
      YES, I AGREE
    </button>
  </div>
</aside>
